import { render, staticRenderFns } from "./CharactersSlider.vue?vue&type=template&id=e6b0f5de&scoped=true&"
import script from "./CharactersSlider.vue?vue&type=script&lang=js&"
export * from "./CharactersSlider.vue?vue&type=script&lang=js&"
import style0 from "./CharactersSlider.vue?vue&type=style&index=0&id=e6b0f5de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b0f5de",
  null
  
)

export default component.exports